<template>
  <div>
    <!-- 导入处方 -->
    <el-dialog title="导入处方"
               width="1200px"
               custom-class="channel-pzescription-dia"
               :visible.sync="channelPzescriptionDia"
               :before-close="close">
      <div style="padding:10px 20px">
        <div class="search_box">
          <div class="item">
            <span>医生姓名</span>
            <el-input v-model="searchForm.doctor_name"
                      size="medium"
                      clearable
                      placeholder="医生姓名"
                      disabled
                      class="input_width"></el-input>
          </div>
          <div class="item">
            <span>患者姓名</span>
            <el-input v-model="searchForm.user_name"
                      size="medium"
                      clearable
                      @change="seachEnterFun"
                      placeholder="患者姓名"
                      class="input_width"></el-input>
          </div>
          <div class="item">
            <span>处方号</span>
            <el-input v-model="searchForm.pre_id"
                      size="medium"
                      clearable
                      @change="seachEnterFun"
                      placeholder="处方号"
                      class="input_width"></el-input>
          </div>

          <div class="item">
            <span>来源</span>
            <el-select v-model="searchForm.pre_type"
                       size="medium"
                       clearable
                       placeholder="来源"
                       @change="getPreList"
                       class="input_width">
              <el-option v-for="item in preTypeOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
            <el-button type="primary"
                       size="medium"
                       style="margin-left:20px"
                       @click="seachEnterFun">查询</el-button>
          </div>

        </div>
        <div style="border:1px solid #f5f5f5">
          <el-table v-loading="tableLoading"
                    :data="pzescriptionTableDiaData"
                    tooltip-effect="dark"
                    height="500px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column v-for="item in channelPzescriptionHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :align="item.align">
              <template slot-scope="scope">
                <div v-if="item.prop == 'user_info' ">
                  <span>{{ scope.row.user_name }}&nbsp;&nbsp;</span>
                  <span>{{ scope.row.sex | sexText }}&nbsp;&nbsp;</span>
                  <span>{{ scope.row.age }}</span>
                </div>
                <div v-else-if="item.prop == 'create_time' ">
                  <span>{{ scope.row[item.prop] | dateFormat }}</span>
                </div>
                <div v-else-if="item.prop == 'pre_type' ">
                  <span>{{ scope.row[item.prop] | preTypeText }}</span>
                </div>
                <div v-else-if="item.prop == 'status' ">
                  <span>{{ scope.row[item.prop] | statusText }}</span>
                </div>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             align="center">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="selectBtn(scope.row)">复用该处方</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="between align-center">
          <!-- 分页 -->
          <pagination v-show="totalNum>0"
                      :total="totalNum"
                      :page.sync="pagination.page"
                      :limit.sync="pagination.pageNumber"
                      @pagination="getPreList" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import common from '@/api/common.js';
import yewu from '@/api/yewu.js';
import system from '@/api/system.js';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  props: {
    channelPzescriptionDia: {
      type: Boolean,
      require: true
    },
    doctor_info: {
      type: Object,
      require: true
    },
    pre_type: {
      type: [String, Number],
      require: true
    }
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      channelPzescriptionHeader: [
        {
          label: '患者信息',
          prop: 'user_info',
          align: 'center'
        },
        {
          label: '处方号',
          prop: 'pre_id',
          align: 'center'
        },
        {
          label: '开方时间',
          prop: 'create_time',
          align: 'center'
        },
        {
          label: '来源',
          prop: 'pre_type',
          align: 'center'
        },
        {
          label: '处方状态',
          prop: 'status',
          align: 'center'
        }
      ],
      pzescriptionTableDiaData: [],
      searchForm: {
        doctor_id: '',
        doctor_name: '',
        user_name: '',
        pre_id: '',
        pre_type: ''
      },
      preTypeOptions: [
        { label: '咨询开方', value: 1 },
        { label: '在线开方', value: 2 },
        { label: '重新开方', value: 3 },
        { label: '云诊所开方', value: 4 },
        { label: '手机号开方', value: 5 },
        { label: '微信开方', value: 6 },
        { label: '视频问诊开方', value: 7 },
        { label: '按方购药', value: 8 },
        { label: '拍方购药', value: 9 },
        { label: '医生拍照开方', value: 11 }
      ],
      tableLoading: false
    };
  },
  filters: {
    sexText(val) {
      switch (val) {
        case 1:
          return '男';
        case 2:
          return '女';
        default:
          return '未知';
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return '待取药';
        case 2:
          return '待审方';
        case 3:
          return '已通过';
        case 4:
          return '已抓药';
        case 5:
          return '过期未取药';
        case 6:
          return '审方不通过';
        case 7:
          return '医生手动作废';
        case 8:
          return '平台退款';
      }
    },
    preTypeText(val) {
      switch (val) {
        case 1:
          return '咨询开方';
        case 2:
          return '在线开方';
        case 3:
          return '重新开方';
        case 4:
          return '云诊所开方';
        case 5:
          return '手机号开方';
        case 6:
          return '微信开方';
        case 7:
          return '视频问诊开方';
        case 8:
          return '按方购药';
        case 9:
          return '拍方购药';
        case 11:
          return '医生拍照开方';
      }
    },
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  watch: {
    channelPzescriptionDia: {
      handler: function (n) {
        if (n) {
          this.restForm();
          this.searchForm.doctor_id = this.doctor_info.doctor_id;
          this.searchForm.doctor_name = this.doctor_info.doctor_name;
          this.searchForm.pre_type = this.pre_type;
          this.getPreList();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getPreList() {
      let data = _.omit(this.searchForm, ['doctor_name']);
      let params = { ...this.pagination, ...data };
      this.tableLoading = true;
      common.getPreList(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.pzescriptionTableDiaData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    // 详情
    prescriptionItem(pre_id) {
      const loading = this.$loading();
      let params = { pre_id };
      yewu
        .prescriptionItem(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.$emit('update:channelPzescriptionDia', false);
            this.$emit('selectData', data.info);
          }
          loading.close();
        })
        .catch((err) => {});
      loading.close();
    },
    restForm() {
      for (let key in this.searchForm) {
        this.searchForm[key] = '';
      }
    },
    selectBtn(row) {
      this.prescriptionItem(row.pre_id);
    },
    close() {
      this.$emit('update:channelPzescriptionDia', false);
    },
    seachEnterFun() {
      this.pagination.page = 1;
      this.getPreList();
    }
  }
};
</script>

<style lang="scss" scoped>
.search_box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .item {
    height: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 80px;
      margin-right: 10px;
      text-align: right;
      white-space: nowrap;
    }
  }
  .input_width {
    width: 160px;
  }
}
</style>